import { EChartOption } from "echarts";

export const budgetVsForecastConfig = (
  xAxis: string[],
  series: { budget: number[]; forecast: number[] },
  budgetLabel: string,
  forecastLabel
): EChartOption => ({
  tooltip: {
    trigger: "axis"
  },
  legend: {
    data: ["Budget", "Forecast"],
    bottom: 0
  },
  toolbox: {
    show: true,
    feature: {
      dataView: { show: true, readOnly: false },
      magicType: { show: true, type: ["line", "bar"] },
      restore: { show: true },
      saveAsImage: { show: true }
    }
  },
  xAxis: [
    {
      type: "category",
      data: xAxis
    }
  ],
  yAxis: [
    {
      type: "value"
    }
  ],
  series: [
    {
      name: budgetLabel,
      type: "bar",
      data: series.budget
    },
    {
      name: forecastLabel,
      type: "bar",
      data: series.forecast
    }
  ]
});
